import React from "react";

const CustomModal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay" onClick={onClose}>
      <div
        className="custom-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="custom-modal-header">
          <h5>{title}</h5>

          <button
            type="button"
            className="custom-modal-close"
            onClick={onClose}
          >
            <i className="fa fa-times" />
          </button>
        </div>

        <div className="custom-modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default CustomModal;